<template>
  <div v-if="onHold">
    <!-- <v-card class="my-3"> -->
      <!-- <v-card-title class="title card-title-head">
        {{ $i18n.t("On Hold Supplier Amount") }}
        <v-spacer />
      </v-card-title> -->
      <v-card-text class="py-0 text-body-1">
        <v-row>
          <v-col cols="12" sm="6" md="3" lg="2">
            <v-subheader
              >{{ $i18n.t("On Hold Amount") }} : {{ onHold.amount }}</v-subheader
            >
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2">
            <v-subheader
              >{{ $i18n.t("Status") }} :
              {{ getStatus(onHold.status) }}</v-subheader
            >
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="5" class="py-2">
            <v-subheader
              >{{ $i18n.t("Comment") }} :
              <div v-html="getComment(onHold.comments)" class="text-size"
            /></v-subheader>
            <!-- <v-subheader
              >{{ $i18n.t("Comment") }} :
              {{ getComment(onHold.comments) }}</v-subheader
            > -->
          </v-col>
          <v-col cols="12" sm="4" md="4" lg="3" style="align-self: center">
            <v-row>
              <v-col cols="12" sm="6" md="6" lg="6">
                <v-btn
                  small
                  color="orange lighten-2"
                  :title="$i18n.t('Show Log')"
                  @click="showCommentLog = true"
                >
                  <!-- <v-icon>mdi-database</v-icon> -->
                  {{$i18n.t("Change Log")}}
                </v-btn></v-col
              >
              <v-spacer></v-spacer>
              <v-col cols="12" sm="6" md="6" lg="6"
                ><v-btn
                  small
                  color="blue lighten-2"
                  :title="
                    onHold.amount == null && onHold.status == null
                      ? $i18n.t('Add Hold Amount')
                      : $i18n.t('Update Hold Amount')
                  "
                  @click="showUpdateOnHold = true"
                >
                  {{
                    onHold.amount == null && onHold.status == null
                      ? $i18n.t("Add Hold Amount")
                      : $i18n.t("Update Hold Amount")
                  }}
                </v-btn></v-col
              >
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    <!-- </v-card> -->
    <on-hold-update
      :showUpdateOnHold="showUpdateOnHold"
      @closeOnHoldDialog="closeOnHoldDialog"
      @reload="reload"
      :trip_id="trip_id"
      :onHold="onHold"
      :supplier_id="supplier_id"
    ></on-hold-update>
    <all-comments-dialog
      :showAllCommentDialog="showCommentLog"
      @closeCommentDialog="closeCommentDialog"
      :comments="onHold.comments"
    ></all-comments-dialog>
  </div>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import { Vue, Component } from "vue-property-decorator";
import OnHoldUpdate from "@/views/trip/OnHoldUpdate.vue";
import AllCommentsDialog from "@/views/comment/AllCommentsDialog.vue";

@Component({
  name: "OnHold",
  props: {
    value: {
      default: false,
    },
    onHold: {
      default: null,
    },
    trip_id: {
      default: null,
    },
    fare: {
      default: null,
    },
    supplier_id: {
      default: null,
    },
  },
  components: {
    OnHoldUpdate,
    AllCommentsDialog,
  },
})
export default class OnHold extends (Vue, Themeable) {
  showUpdateOnHold = null;
  showCommentLog = null;
  mounted() {
    if (!this.onHold) {
      this.onHold = {};
    }
  }
  async reload(reload) {
    this.$emit("reload", reload);
    this.closeOnHoldDialog();
  }
  closeOnHoldDialog() {
    this.showUpdateOnHold = null;
  }
  closeCommentDialog() {
    this.showCommentLog = null;
  }
  getStatus(status) {
    if (status != null) {
      if (status == 0) return "On Hold";
      if (status == 1) return "Cleared";
    }
    return "";
  }
  getComment(comments) {
    if (comments && comments.length > 0) {
      return comments[comments.length - 1]
        ? comments[comments.length - 1].msg
        : "";
    }
    return "";
  }
}
</script>

<style scoped>
.card-title-head {
  background-color: rgb(211, 235, 240);
  height: 40px;
  padding-top: 0px;
  color: #3b7776;
}
</style>
